<ion-header>
  <div class="flex-space-between" style="padding: 8px">
    <div class="button-container flexed-align-center">
      <div class="flexed-align-center">
        <ion-searchbar
          mode="ios"
          placeholder="Search accounts..."
          showCancelButton="never"
          class="rounded-search-bar"
          [(ngModel)]="searchText"
          (ionChange)="handleFilters()"
        ></ion-searchbar>
        <app-filter-button
          [options]="filterOptions"
          (didChange)="filtersDidChange($event)"
          [projectId]="authService.selectedProject?.id ?? undefined"
        ></app-filter-button>
      </div>
    </div>
    <div style="display: flex">
      <ion-button
        [hidden]="selectedAccounts.length"
        (click)="addIndividualAccount()"
      >
        <ion-icon name="add-outline"></ion-icon>
        <span class="text-with-left-icon hidden-sm"> Add account </span>
      </ion-button>
      <ion-button
        fill="clear"
        color="dark"
        (click)="exportAsCsv()"
        ngxTippy
        [tippyProps]="{
          arrow: false,
          placement: 'bottom'
        }"
        data-tippy-content="Download as CSV"
        class="hidden-sm"
      >
        <ion-icon name="cloud-download"></ion-icon>
      </ion-button>
    </div>
  </div>
  <div [hidden]="!selectedAccounts.length" style="padding: 8px">
    <ion-button fill="clear" color="dark" [disabled]="true" class="btn-small">
      {{
        selectAllPagesForBulkUpdate
          ? accountListDataSource.lastResponse.totalCount
          : selectedAccounts.length
      }}
      selected:
    </ion-button>
    <ion-button
      (click)="manageTags()"
      [disabled]="isLoading"
      color="light"
      style="margin: 0 4px"
      class="btn-small"
    >
      <ion-icon name="pricetags"></ion-icon>
      <span class="text-with-left-icon hidden-sm"> Manage tags </span>
    </ion-button>
    <!-- <ion-button fill="outline" (click)="showEditOptions()" [disabled]="isLoading" style="margin: 0 4px">
      <span class="text-with-right-icon hidden-sm"> Edit </span>
      <ion-icon name="chevron-down-outline" class="button-icon"></ion-icon>
    </ion-button> -->
    <ng-container *ngIf="selectedAccounts.length >= limit">
      <ng-container *ngIf="!selectAllPagesForBulkUpdate">
        <ion-button
          fill="clear"
          color="dark"
          (click)="selectAllPagesForBulkUpdate = true"
          class="btn-small"
        >
          Select all
          {{ accountListDataSource.lastResponse.totalCount }} accounts?
        </ion-button>
      </ng-container>
    </ng-container>
    <ion-button
      fill="clear"
      color="dark"
      (click)="selectedAccounts = []; selectAllPagesForBulkUpdate = false"
      [disabled]="isLoading"
      style="margin: 0 4px"
      class="btn-small"
    >
      Clear selection
    </ion-button>
  </div>
</ion-header>
<ion-content>
  <ng-container>
    <ngx-datatable
      class="material datatable-row-borders datatable-fixed-header datatable-fixed-footer"
      [columnMode]="ColumnMode.force"
      [limit]="limit"
      [headerHeight]="44"
      [footerHeight]="50"
      [rowHeight]="50"
      [scrollbarH]="true"
      [selected]="selectedAccounts"
      selectionType="checkbox"
      [selectAllRowsOnPage]="false"
      [displayCheck]="false"
      style="height: unset"
      paginated
      [dataSource]="accountListDataSource"
      [reorderable]="true"
      (select)="onSelect($event)"
      [loadingIndicator]="isLoading"
    >
      <ngx-datatable-column
        [width]="44"
        [minWidth]="44"
        [sortable]="false"
        [canAutoResize]="false"
        [draggable]="false"
        [resizeable]="false"
        [headerCheckboxable]="true"
        [checkboxable]="true"
      >
      </ngx-datatable-column>

      <ngx-datatable-column name="Name" [minWidth]="250">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <a
            (click)="editAccount(row.id)"
            routerDirection="root"
            class="vertical-align-center row-title row-link"
            style="font-weight: 600"
          >
            <div style="width: 29px; height: 29px; margin-right: 10px">
              @if (row.imageUrl) {
                <img
                  [src]="row.imageUrl"
                  style="
                    object-fit: cover;
                    border-radius: 8px;
                    box-shadow: 0 0 0px 1px
                      rgba(var(--ion-color-primary-rgb), 0.2);
                  "
                />
              } @else {
                <div
                  *ngIf="!row.imageUrl"
                  style="
                    width: 100%;
                    border-radius: 8px;
                    background: rgba(var(--ion-color-primary-rgb), 0.05);
                    color: rgba(var(--ion-color-primary-rbg), 0.7);
                    height: 100%;
                    padding: 7px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 0.95rem;
                    box-shadow: 0 0 0px 1px
                      rgba(var(--ion-color-primary-rgb), 0.2);
                  "
                >
                  <ion-icon name="business"></ion-icon>
                </div>
              }
            </div>
            {{ row.name ?? PRIVATE_CHANNEL_NAME }}
          </a>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Domains" [minWidth]="200" [sortable]="false">
        <ng-template let-row="row" ngx-datatable-cell-template>
          @for (emailOrDomain of row.emailsAndDomains; track emailOrDomain) {
            <ion-badge color="warning"> {{ emailOrDomain }} </ion-badge>
          } @empty {
            <i>None</i>
          }
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        name="Slack Channels"
        prop="slackChannels"
        [minWidth]="225"
        [sortable]="false"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <ion-badge color="light">
            @for (slackChannel of row.slackChannels; track slackChannel.id) {
              @if (slackChannel.name !== PRIVATE_CHANNEL_NAME) {
                @if (slackChannel.isPrivate) {
                  <ion-icon name="lock-closed"></ion-icon>
                } @else {
                  <span>#</span>
                }
              }
              <span>{{ slackChannel.name }}</span>
            } @empty {
              <i>None</i>
            }
          </ion-badge>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        name="Slack Teams"
        prop="slackTeams"
        [minWidth]="225"
        [sortable]="false"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          @for (slackTeam of row.slackTeams; track slackTeam.id) {
            <span>{{ slackTeam.name }}</span>
          } @empty {
            <i>None</i>
          }
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column name="Tags" [minWidth]="250" [sortable]="false">
        <ng-template let-row="row" ngx-datatable-cell-template>
          <ion-badge
            color="success"
            *ngFor="let tag of row.tags"
            (click)="editTagForAccount(row.id, tag.id)"
            class="clickable"
          >
            <span [title]="getTagsForRow(row)"> {{ tag.name }} </span>
          </ion-badge>
          <ion-button
            class="btn-small"
            fill="clear"
            color="dark"
            style="--padding-start: 4px; --padding-end: 4px; opacity: 0.8"
            (click)="addTagToAccount(row.id)"
          >
            <ion-label>
              <ion-icon name="pricetag"></ion-icon
              ><ion-icon name="add-outline"></ion-icon>
            </ion-label>
          </ion-button>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        name="Primary rep"
        prop="primaryRep"
        [minWidth]="200"
        [sortable]="false"
      >
        <ng-template
          let-value="value"
          let-row="row"
          ngx-datatable-cell-template
        >
          <ion-button
            class="btn-small"
            fill="clear"
            color="dark"
            (click)="showAssigneeOptions(row, true)"
            style="margin-left: -13px"
            [disabled]="isLoadingAssignees && row.primarySupportAssigneeId"
          >
            <ion-label>
              {{
                isLoadingAssignees && row.primarySupportAssigneeId
                  ? "Loading..."
                  : assigneeLookups[row.primarySupportAssigneeId]
                      ?.displayName ?? "No one"
              }}
              <ion-icon
                name="caret-down-outline"
                class="icon-padded-left"
              ></ion-icon>
            </ion-label>
          </ion-button>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        name="Secondary rep"
        prop="primaryRep"
        [minWidth]="200"
        [sortable]="false"
      >
        <ng-template
          let-value="value"
          let-row="row"
          ngx-datatable-cell-template
        >
          <ion-button
            class="btn-small"
            fill="clear"
            color="dark"
            (click)="showAssigneeOptions(row, false)"
            style="margin-left: -13px"
            [disabled]="isLoadingAssignees && row.secondarySupportAssigneeId"
          >
            <ion-label>
              {{
                isLoadingAssignees && row.secondarySupportAssigneeId
                  ? "Loading..."
                  : assigneeLookups[row.secondarySupportAssigneeId]
                      ?.displayName ?? "No one"
              }}
              <ion-icon
                name="caret-down-outline"
                class="icon-padded-left"
              ></ion-icon>
            </ion-label>
          </ion-button>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        name="CRM"
        prop="externalCrmMetadata"
        [sortable]="false"
        [minWidth]="200"
        *ngIf="connectedCrm"
      >
        <ng-template let-row="row" ngx-datatable-cell-template>
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <ion-button
              class="btn-small"
              color="light"
              (click)="openLink(row.externalCrmMetadata.url)"
              *ngIf="row?.externalCrmMetadata?.id"
            >
              Open in {{ connectedCrm }}
              <ion-icon name="open" class="icon-padded-left"></ion-icon>
            </ion-button>
            <ion-button
              class="btn-small button-dark-border"
              color="dark"
              fill="clear"
              (click)="linkCrm(row)"
              *ngIf="!row?.externalCrmMetadata?.id"
            >
              <ion-icon name="unlink-outline" class="padded-icon"></ion-icon>
              Connect
            </ion-button>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        name="Created"
        prop="createdAt"
        [minWidth]="170"
        [maxWidth]="170"
        [width]="170"
      >
        <ng-template
          let-value="value"
          let-row="row"
          ngx-datatable-cell-template
        >
          {{ value | date: "MMM d yyyy" }}
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
    <div *ngIf="allAccounts && !allAccounts.length && searchText?.length">
      <ion-card class="outline-card">
        <div class="empty-state-container" style="padding: 60px">
          <span class="placeholder-emoji">
            <ion-icon name="business-outline"></ion-icon>
          </span>
          <h1 class="placeholder-title">No results</h1>
        </div>
      </ion-card>
    </div>
  </ng-container>
  <div *ngIf="allAccounts && !allAccounts.length && !searchText?.length">
    <ion-card class="outline-card">
      <div class="empty-state-container" style="padding: 60px">
        <span class="placeholder-emoji">
          <ion-icon name="business-outline"></ion-icon>
        </span>
        <h1 class="placeholder-title">No accounts yet</h1>
        <p class="placeholder-subtitle">You should probably create one, eh?</p>
        <a [routerLink]="'/accounts/new'">Create an account</a>
      </div>
    </ion-card>
  </div>
</ion-content>
